
/**
 * Created by asiulik on 20.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../store/favouriteStore'], function($, _, EventEmitter, FavouriteStore){


    var config = {
        overlayTriggerSelector: "[data-overlay]",
        overlayTriggerAttr: "data-overlay"
    };

    function OverlayTermin(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlayTermin.prototype = _.clone(EventEmitter.prototype);

    OverlayTermin.prototype.init = function(){

        this.$triggerElements = $(config.overlayTriggerSelector);
        this.bindEvents();

    };

    OverlayTermin.prototype.bindEvents = function(){

        var _this = this;

        this.$triggerElements.on({
            click: function(e){
                e.preventDefault();
                var $this = $(this);

                _this.openTerminOverlay($this);
            }
        })

    };

    OverlayTermin.prototype.openTerminOverlay = function($triggerElement){

        this.overlay.openOverlay(
            $($triggerElement.attr(config.overlayTriggerAttr))
        );

    };


    return OverlayTermin

});




// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlayDefault.js